import(/* webpackMode: "eager" */ "/home/prince/upwork-uphunt/src/app/page.tsx");
